<div id="toro-ah-snap">
    <div id="ah-snap-tag-line">Ah Snap!</div>
    <div id="ah-snap-sub-text">Something went wrong...</div>
    <div id="ah-snap-retry" (click)="onRetry()">Try Again</div>
</div>
